<template>
  <div class="component-container" :key="sectionInfo.title">
    <div class="band-title-wrap">
      <h3 class="component-title" tabindex="0" v-band-title>{{sectionInfo.title}}</h3>
      <span class="search-result-number" :aria-label="'검색 결과 ' + sectionInfo.count + '건'">{{sectionInfo.count}}</span>
    </div>
    <a href="#" @click.prevent="changeKeywordTab" class="link-band-list search-result" :aria-label="'검색 결과 ' + sectionInfo.count + '건 모두보기'">{{sectionInfo.count}}</a>
    <div class="search-customer-wrap" v-if="(faqList && faqTotalCount> 0)">
      <h4 class="search-customer-hd">
        <searchButtonFaq />
        <span>FAQ</span>
      </h4>
      <ul class="search-customer-box">
        <li v-for="(faq, index) in faqList" :key="'faq_' + index" @click="clickView('faq', faq.faqid)">
          <span class="search-customer-type">{{faq.faqtypetext}}</span>
          <span class="search-customer-title" v-keyword-color="{keyword:keyword, title:faq.faqtitle}"></span>
        </li>
      </ul>
      <span class="cell-list-more" @click.prevent="clickCustomer('faq')">
        <span>더보기</span>
        <NextButtonWhite />
      </span>

    </div>
    <div class="search-customer-wrap" v-if="(noticeList && noticeTotalCount > 0)">
      <h4 class="search-customer-hd">
        <searchButtonNotice />
        <span>공지사항</span>
      </h4>
      <ul class="search-customer-box">
        <li v-for="(notice, index) in noticeList" :key="'notice_' + index" @click="clickView('notice_view', notice.noticeid)">
          <span class="search-customer-type">{{notice.noticetypetext}}</span>
          <span class="search-customer-title" v-keyword-color="{keyword:keyword, title:notice.noticetitle}"></span>
        </li>
      </ul>
      <span class="cell-list-more" @click.prevent="clickCustomer('notice_list')">
        <span>더보기</span>
        <NextButtonWhite />
      </span>
    </div>

  </div>
</template>

<script>
  import {EventService, SearchService} from '@/common/api/api.service'
import { bandTitle, keywordColor } from '@/common/directives'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import searchButtonFaq from '@/assets/svg/common/ic_label_faq.svg'
import searchButtonNotice from '@/assets/svg/common/ic_label_notice.svg'
import { EventBus } from '@/components/eventbus/EventBus'
import { get } from 'lodash'

export default {
  name: 'Customer',
  components: {
    NextButtonWhite,
    searchButtonFaq,
    searchButtonNotice
  },
  data () {
    return {
      noticeList: [],
      faqList: [],
      totalCount: 0,
      offset: 0,
      orderby: 'score',
      faqTotalCount: 0,
      noticeTotalCount: 0
    }
  },
  directives: { bandTitle, keywordColor },
  props: { sectionInfo: { type: Object }, keyword: { type: String } },
  methods: {
    async setData () {
      // SearchService.keywordSearch({
      //   keyword: this.keyword,
      //   orderby: this.orderby,
      //   limit: 5,
      //   offset: this.faqOffset,
      //   type: 'faq'
      // }).then((faqRes) => {
      //   this.faqList = get(faqRes, ['data', '1', 'list'], [])
      //   this.faqTotalCount = parseInt(get(faqRes, ['data', '0', 'totalcount'], '0'))
      //   this.totalCount = this.totalCount + this.faqTotalCount
      // })
      //
      // SearchService.keywordSearch({
      //   keyword: this.keyword,
      //   orderby: this.orderby,
      //   limit: 5,
      //   offset: this.noticeOffset,
      //   type: 'notice'
      // }).then((noticeRes) => {
      //   this.noticeList = get(noticeRes, ['data', '1', 'list'], [])
      //   this.noticeTotalCount = parseInt(get(noticeRes, ['data', '0', 'totalcount'], '0'))
      //   this.totalCount = this.totalCount + this.noticeTotalCount
      // })
      const { data } = await EventService.requestEventData(get(this.sectionInfo, 'contentEvent', {}))
      this.faqList = get(data, '1.list', [])
      this.faqTotalCount = Number(get(data, '1.totalcount', '0'))
      this.noticeList = get(data, '2.list', [])
      this.noticeTotalCount = Number(get(data, '2.totalcount', '0'))
      this.totalCount = Number(get(data, '0.totalcount', 0))
    },
    changeKeywordTab () {
      EventBus.$emit('tab-type', 'faq')
    },
    clickCustomer (type) {
      this.$router.push({
        name: type,
        params: {
          keyword: this.keyword
        }
      })
    },
    clickView (type, idx) {
      if (type === 'notice_view') {
        this.$router.push({ 'path': `customer/${type}/${idx}` })
      } else {
        this.$router.push({ 'path': `customer/${type}?faqid=${idx}` })
      }
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
